import { tableFiltersUrl } from '../../utils/helper'
import request from '../axiosInterceptor'

const api = {
  getQuizAssessments(data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/quiz/assessment/list?${tableFiltersUrl(data)}`,
      method: 'get',
    })
  },
  getQuizAssessmentDetails(attemptId: string | number) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/quiz/assessment/${attemptId}`,
      method: 'get',
    })
  },
//   getExportQuizAssessments(format: string, id?: string | number) {
//     const url = id
//       ? `${process.env.REACT_APP_API_BASEURL}v1/quiz-assessments/export?project_id=${id}&format=${format}`
//       : `${process.env.REACT_APP_API_BASEURL}v1/quiz-assessments/export?format=${format}`
//     return request({
//       url,
//       method: 'get',
//       responseType: 'blob',
//     })
//   },
}

export default api

